
<div style="margin-bottom:15px;">
  <mat-checkbox [formControl]="formControl"><span innerHTML="{{ field.templateOptions.label }}"></span> <span><a [routerLink]="sharedService.buildRoute(['page', 'legal-warning-privacy-policy'])" target='new'>{{ "page.legal-warning-privacy-policy.title" | translate }}</a></span></mat-checkbox>
</div>




